import { gql, useQuery } from "@apollo/client";
import { StatCard } from "./StatsUI";
import PawLoader from "../../components/PawLoader";

const MY_STATS_QUERY = gql`
  query MyStats {
    myStats {
      firstName
      uniqueVideosViewed
      totalClicks
      totalAvailableVideos
    }
  }
`;

const PersonalStats = () => {
  const { data, loading, error } = useQuery(MY_STATS_QUERY, {
    fetchPolicy: "network-only", // always go to the server
    nextFetchPolicy: "cache-first", // then cache the result
    notifyOnNetworkStatusChange: true, // lets you show loading states on refetch
  });

  if (loading)
    return (
      <div className="h-[300px] my-5">
        <PawLoader size={100} />
      </div>
    );

  if (error)
    return (
      <div className="h-[300px] my-5">
        <p>Error loading personal stats</p>
      </div>
    );

  const { firstName, uniqueVideosViewed, totalClicks, totalAvailableVideos } =
    data.myStats;

  return (
    <>
      <h1 className="text-3xl font-bold">Great Job, {firstName}!</h1>
      <div className="grid grid-cols-2 gap-4 my-6">
        <StatCard
          title="Puppies Watched"
          value={uniqueVideosViewed}
          maxValue={totalAvailableVideos}
          subtitle="Great job annotating!"
        />
        <StatCard
          title="Total Clicks"
          value={totalClicks}
          maxValue={500}
          subtitle="Keep going!"
        />
      </div>
    </>
  );
};

export default PersonalStats;
